@let userTimelinesInfo = userTimelinesInfo$ | async;
@let resourcesColumnWidthPx = resourcesColumnWidthPx$ | async;
@let isCellView = isCellView$ | async; @let timelineHeight = '100%';
@let sortedUserTimelinesInfo = sortedUserTimelinesInfo$ | async;
@let rowHeightWithBorder = rowHeightWithBorder$ | async;
@let areActivitiesVisible = areActivitiesVisible$ | async;

@if ((isLoadingData$ | async) || (isForcingRerender$ | async)) {
  <div class="content mb-3 p-4 w-100 h-100">
    <wilson-timeline-content-loader></wilson-timeline-content-loader>
  </div>
} @else {
  <div
    #shiftTimelineWrapper
    id="shift-timeline"
    class="flex-grow-1"
    [ngClass]="
      (isFilterDrawerVisible$ | async)
        ? 'timeline-open-filter-width'
        : 'timeline-full-width'
    "
  >
    @if (isCellView === true) {
      <div class="content mb-3 w-100 h-100">
        <cdk-virtual-scroll-viewport
          [appendOnly]="true"
          [itemSize]="rowHeightWithBorder"
          #rowsContainerVirtualScroll
          class="rows-container"
          [style.max-height]="timelineHeight"
          (scroll)="
            scrollDebouncerSubject.next({
              viewPort: rowsContainerVirtualScroll,
              totalItems: userTimelinesInfo?.length || 0,
            })
          "
        >
          <wilson-shift-timeline-gantt-header
            [scrollLeftPx]="currentScrollLeftPositionSubject.value"
            [stickyHasShadow]="stickyHasShadow"
            [viewport]="shiftTimelineWrapper"
          ></wilson-shift-timeline-gantt-header>
          @if (sortedUserTimelinesInfo?.length) {
            <wilson-timeline-cell-view-user-row
              [theoreticalListRange]="theoreticalListRange$ | async"
              [viewport]="
                rowsContainerVirtualScroll.getElementRef().nativeElement
              "
              [stickyHasShadow]="stickyHasShadow"
              [users]="sortedUserTimelinesInfo"
              [rowHeightWithBorder]="rowHeightWithBorder"
              [weekendHolidayRenderData]="
                (weekendHolidayRenderData$ | async) || []
              "
            ></wilson-timeline-cell-view-user-row>
          } @else {
            <ng-container *ngTemplateOutlet="emptyState"></ng-container>
          }
        </cdk-virtual-scroll-viewport>
      </div>
      <div class="content unassigned-region-container w-100">
        @if (
          'portal-shift-timeline-unassigned-section' | featureFlagPure | async
        ) {
          <wilson-unassigned-region-resize-handle
            (resizeStart)="cellViewUnassignedRegion.onResizeStart()"
            (resizing)="cellViewUnassignedRegion.onResize($event)"
            (resizeEnd)="cellViewUnassignedRegion.onResizeEnd($event)"
          ></wilson-unassigned-region-resize-handle>
          <wilson-cell-view-timeline-unassigned-region
            #cellViewUnassignedRegion
            [scrollLeftPx]="currentScrollLeftPositionSubject.value"
            (scrolling)="setScrollHorizontalPosition($event)"
            (heightAppliedManually)="onUnassignedRegionHeightAppliedManually()"
          ></wilson-cell-view-timeline-unassigned-region>
        }
      </div>
      <wilson-cell-view-drawers></wilson-cell-view-drawers>
    } @else if (isCellView === false) {
      <wilson-demarcator-lines
        [scrollLeftPx]="currentScrollLeftPositionSubject.value"
      ></wilson-demarcator-lines>
      <div class="content mb-3 w-100 h-100">
        <cdk-virtual-scroll-viewport
          [appendOnly]="true"
          [itemSize]="rowHeightWithBorder"
          #rowsContainerVirtualScroll
          class="rows-container"
          [style.max-height]="timelineHeight"
          (scroll)="
            scrollDebouncerSubject.next({
              viewPort: rowsContainerVirtualScroll,
              totalItems: userTimelinesInfo?.length || 0,
            })
          "
        >
          <wilson-shift-timeline-gantt-header
            [scrollLeftPx]="currentScrollLeftPositionSubject.value"
            [stickyHasShadow]="stickyHasShadow"
            [viewport]="shiftTimelineWrapper"
          ></wilson-shift-timeline-gantt-header>
          @if (sortedUserTimelinesInfo?.length) {
            <wilson-timeline-user-row-v2
              [theoreticalListRange]="theoreticalListRange$ | async"
              [stickyHasShadow]="stickyHasShadow"
              [users]="sortedUserTimelinesInfo"
              [rowHeightWithBorder]="rowHeightWithBorder"
              [weekendHolidayRenderData]="
                (weekendHolidayRenderData$ | async) || []
              "
            ></wilson-timeline-user-row-v2>
            @if (areActivitiesVisible) {
              <div
                wilsonMouseMovementHandler
                class="resize-activity"
                [style.z-index]="
                  (mouseMovementHelperService.isUserDraggingActivity$ | async)
                    ? 20
                    : -1
                "
                [style.left.px]="resourcesColumnWidthPx"
              ></div>
            }
          } @else {
            <ng-container *ngTemplateOutlet="emptyState"></ng-container>
          }
        </cdk-virtual-scroll-viewport>
      </div>
      <div class="content unassigned-region-container w-100">
        @if (
          'portal-shift-timeline-unassigned-section' | featureFlagPure | async
        ) {
          <wilson-unassigned-region-resize-handle
            (resizeStart)="regularViewUnassignedRegion.onResizeStart()"
            (resizing)="regularViewUnassignedRegion.onResize($event)"
            (resizeEnd)="regularViewUnassignedRegion.onResizeEnd($event)"
          ></wilson-unassigned-region-resize-handle>
          <wilson-regular-view-timeline-unassigned-region
            #regularViewUnassignedRegion
            [scrollLeftPx]="currentScrollLeftPositionSubject | async"
            (scrolling)="setScrollHorizontalPosition($event)"
            (heightAppliedManually)="onUnassignedRegionHeightAppliedManually()"
          ></wilson-regular-view-timeline-unassigned-region>
        }
      </div>
      <wilson-standard-view-drawers></wilson-standard-view-drawers>
    }
    @if (absenceDrawerHelperService.isAbsenceDrawerVisible$ | async) {
      <wilson-timeline-absence-drawer></wilson-timeline-absence-drawer>
    }
  </div>
}

<ng-template #emptyState>
  @let isCollapsed = isCollapsed$ | async;
  <wilson-timeline-empty-filters-state
    [isCollapsed]="!!isCollapsed"
  ></wilson-timeline-empty-filters-state>
</ng-template>
